import React, { useEffect, useMemo, useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DashboardFilters = ({ filters, onChange, printers = [], loadingPrinters = false }) => {
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const presetOptions = useMemo(() => ([
    { value: 'current_month', label: 'Mês atual' },
    { value: 'last_30', label: 'Últimos 30 dias' },
    { value: 'last_90', label: 'Últimos 90 dias' },
    { value: 'year_to_date', label: 'Ano atual' },
    { value: 'custom', label: 'Personalizado' }
  ]), []);

  const statusOptions = [
    { value: 'all', label: 'Todos os status' },
    { value: 'in_progress', label: 'Em andamento' },
    { value: 'completed', label: 'Concluídos' },
    { value: 'draft', label: 'Rascunhos' }
  ];

  const printerOptions = useMemo(() => [
    { value: 'all', label: 'Todas as impressoras' },
    ...printers?.map(p => ({ value: p?.id, label: `${p?.brand || ''} ${p?.model || p?.name || ''}`.trim() || (p?.name || 'Impressora') }))
  ], [printers]);

  const presetToRange = (preset) => {
    const today = new Date();
    if (preset === 'current_month') {
      return {
        startDate: startOfMonth.toISOString().slice(0, 10),
        endDate: endOfMonth.toISOString().slice(0, 10)
      };
    }
    if (preset === 'last_30') {
      const start = new Date();
      start.setDate(today.getDate() - 30);
      return { startDate: start.toISOString().slice(0, 10), endDate: today.toISOString().slice(0, 10) };
    }
    if (preset === 'last_90') {
      const start = new Date();
      start.setDate(today.getDate() - 90);
      return { startDate: start.toISOString().slice(0, 10), endDate: today.toISOString().slice(0, 10) };
    }
    if (preset === 'year_to_date') {
      const start = new Date(today.getFullYear(), 0, 1);
      return { startDate: start.toISOString().slice(0, 10), endDate: today.toISOString().slice(0, 10) };
    }
    return { startDate: filters?.startDate, endDate: filters?.endDate };
  };

  const handlePresetChange = (value) => {
    const range = presetToRange(value);
    onChange?.({ ...filters, preset: value, ...range });
  };

  const handleStatusChange = (value) => onChange?.({ ...filters, status: value });
  const handlePrinterChange = (value) => onChange?.({ ...filters, printerId: value });
  const handleStartDateChange = (e) => onChange?.({ ...filters, preset: 'custom', startDate: e?.target?.value });
  const handleEndDateChange = (e) => onChange?.({ ...filters, preset: 'custom', endDate: e?.target?.value });
  const handleReset = () => onChange?.({ preset: 'current_month', status: 'all', printerId: 'all', ...presetToRange('current_month') });

  return (
    <div className="bg-card border border-border rounded-2xl p-4 mb-6">
      <div className="flex flex-col xl:flex-row gap-4 items-stretch xl:items-end">
        <div className="flex-1">
          <Select
            label="Período"
            options={presetOptions}
            value={filters?.preset}
            onChange={handlePresetChange}
            clearable
          />
        </div>
        <div className="flex-1">
          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={handleStatusChange}
            clearable
          />
        </div>
        <div className="flex-1">
          <Select
            label="Impressora"
            options={printerOptions}
            value={filters?.printerId}
            onChange={handlePrinterChange}
            clearable
            loading={loadingPrinters}
            searchable
          />
        </div>
        <div className="flex-1 grid grid-cols-2 gap-3">
          <Input type="date" label="Início" value={filters?.startDate} onChange={handleStartDateChange} />
          <Input type="date" label="Fim" value={filters?.endDate} onChange={handleEndDateChange} />
        </div>
        <div className="flex items-end">
          <Button variant="outline" onClick={handleReset}>
            <Icon name="Filter" size={16} />
            <span className="ml-2">Limpar filtros</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardFilters;